<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import usePlaylistStore from '../../stores/playlist';
import useLocale from '../../composables/useLocale';
import type { GoToItem } from '../../types';
import PlaylistNavigationItem from './PlaylistNavigationItem.vue';

type Emits = {
  (e: 'goToContent', item: GoToItem): void;
};
const emit = defineEmits<Emits>();

type Props = {
  search: string;
};
const props = defineProps<Props>();

const { t } = useLocale();
const { playlist } = storeToRefs(usePlaylistStore());

const filteredItems = computed(() => {
  if (!props.search.trim()) {
    return playlist.value;
  }

  const searchLower = props.search.toLowerCase();

  return playlist.value.filter((item, index) => {
    // Search by segment number
    const segmentText = `segment ${index + 1}`.toLowerCase();
    if (segmentText.includes(searchLower)) {
      return true;
    }

    // Search by href (for debugging purposes)
    if (item.href.toLowerCase().includes(searchLower)) {
      return true;
    }

    return false;
  });
});
</script>

<template>
  <v-sheet data-testid="bp-playlist-tab">
    <v-list v-if="filteredItems.length">
      <PlaylistNavigationItem
        v-for="(item, index) in filteredItems"
        :key="`playlist-${index}`"
        :item="item"
        :index="playlist.indexOf(item)"
        @goToContent="emit('goToContent', $event)"
      />
    </v-list>
    <p v-else class="text-center pa-4">
      {{ t('book_player.message_no_playlist_items') }}
    </p>
  </v-sheet>
</template>
